import { useCallback, useEffect, useState } from "react";
import { apiCall } from "../../services/api";

const getSpringaheadProject = async (id) => {
  const springaheadProject = await apiCall(
    "get",
    `/api/client_projects/${id}/springahead`
  );

  return springaheadProject.project;
};

// SpringAhead's Manager is the project's time approver, and the push in
// sa_update_project may not stick. Asking right after a save is what makes
// the server notice and log it. Silent on purpose: the form already shows
// SpringAhead's manager below Project Manager, so a second notification
// would tell the user what they can already see. A failed check is not a
// failed save.
export const checkManagerAfterSave = async ({ ID, SPRINGAHEAD_ID }) => {
  if (!SPRINGAHEAD_ID) return;
  try {
    await getSpringaheadProject(ID);
  } catch {
    return;
  }
};

export const useSpringaheadProject = (projectId) => {
  const [isLoading, setIsLoading] = useState(false);
  const [springaheadProject, setSpringaheadProject] = useState(null);

  const fetchSpringaheadProject = useCallback(async () => {
    setIsLoading(true);
    try {
      const springaheadProject = await getSpringaheadProject(projectId);
      setSpringaheadProject(springaheadProject);
    } catch {
      return;
    } finally {
      setIsLoading(false);
    }
  }, [projectId]);

  useEffect(() => {
    fetchSpringaheadProject();
  }, [fetchSpringaheadProject]);

  return {
    isLoading,
    springaheadProject,
    refresh: fetchSpringaheadProject,
  };
};
